import ClockPage from './ClockPage';

export default ClockPage;
